import React from 'react'
import { formatDuration } from '../../utils'
import { QuestEnum, SkillEnum, SkillStates, TimelineItem as TimelineItemType } from '@/types'
import { getStory } from '@/constants/story'
import { QUESTS } from '@/constants/quests'
import { Quest } from './Quest'
import { IndividualSkillCard } from './IndividualSkillCard'
import { OverallSkillCard } from './OverallSkillCard'
import SKILL_TREE from '@/constants/skillTree'

interface TimelineItemProps {
  item: TimelineItemType
  gameSkills: SkillStates
  showTime?: boolean
}

export const TimelineItem: React.FC<TimelineItemProps> = ({ item, gameSkills, showTime = true }) => {
  const renderContent = () => {
    switch (item.type) {
      case 'story':
        return <div dangerouslySetInnerHTML={{ __html: getStory()[item.contentRef as number]?.value || '' }} />
      case 'quest':
        return (
          <Quest
            quest={QUESTS[getStory()[item.contentRef as number]?.value as QuestEnum]}
            showTravelToLocation={false}
          />
        )
      case 'skill':
        return (
          <IndividualSkillCard
            skillKey={item.contentRef as SkillEnum}
            reachedLevel={item.reachedValue}
            requiredLevel={item.reachedValue}
            gameSkill={gameSkills[item.contentRef as SkillEnum]}
          />
        )
      case 'overall_skill':
        return (
          <OverallSkillCard
            skillLevel={SKILL_TREE[item.contentRef as number]}
            gameSkills={gameSkills}
            isExpanded={false}
            onToggle={() => {}}
            isTransparent={false}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="mb-8 flex gap-4">
      <div className="flex flex-col items-center">
        <div className="w-4 h-4 bg-blue-600 rounded-full"></div>
        <div className="w-0.5 h-full bg-blue-600"></div>
      </div>
      <div className="flex-1">
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="text-lg text-gray-600 mb-2">
            {item.type === 'story' && '📖 Story ' + ((item.contentRef as number) + 1) + ' '}
            {item.type === 'skill' && '🏆 Reached new skill level '}
            {item.type === 'overall_skill' && '🏄‍♂️ Reached new surf level '}
            {item.type === 'quest' && '✅ Quest '}
            {showTime && (
              <>
                - {formatDuration(item.gameMinutes)}{' '}
                <span className="text-gray-400">({formatDuration(item.realMinutes)})</span>
              </>
            )}
          </div>

          {renderContent()}
        </div>
      </div>
    </div>
  )
}
